// src/app/modules/BulkUpload/context/bulkUploadReducer.js

import { ACTIONS } from "./bulkUploadActions";

export const initialState = {
  activeStep: 0,

  file: null,

  validation: {
    status: "idle", // 'validating' | 'success' | 'error'
    results: {
      valid: [],
      errors: [],
      warnings: [],
    },
    summary: {
      totalRows: 0,
      validRows: 0,
      errorRows: 0,
      warningRows: 0,
      newParents: 0,
      existingParents: 0,
      totalStudents: 0,
    },
  },

  processing: {
    status: "idle", // 'processing' | 'success' | 'error'
    progress: {
      current: 0,
      total: 0,
      percentage: 0,
      currentOperation: "",
    },
    stats: {
      familiesCreated: 0,
      studentsEnrolled: 0,
      duration: 0,
    },
  },

  results: null,
  error: null,
};

export const bulkUploadReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_FILE:
      return {
        ...state,
        file: action.payload,
        error: null,
      };

    case ACTIONS.SET_ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };

    case ACTIONS.SET_VALIDATION_STATUS:
      return {
        ...state,
        validation: {
          ...state.validation,
          status: action.payload,
        },
      };

    case ACTIONS.SET_VALIDATION_RESULTS:
      return {
        ...state,
        validation: {
          ...state.validation,
          status: "success",
          results: action.payload.results,
          summary: action.payload.summary,
        },
      };

    case ACTIONS.SET_PROCESSING_STATUS:
      return {
        ...state,
        processing: {
          ...state.processing,
          status: action.payload,
        },
      };

    case ACTIONS.UPDATE_PROGRESS:
      return {
        ...state,
        processing: {
          ...state.processing,
          progress: {
            ...state.processing.progress,
            ...action.payload,
          },
        },
      };

    case ACTIONS.SET_RESULTS:
      return {
        ...state,
        results: action.payload,
        processing: {
          ...state.processing,
          status: "success",
        },
      };

    case ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case ACTIONS.RESET:
      return initialState;

    case ACTIONS.RESET_VALIDATION:
      return {
        ...state,
        validation: {
          status: "idle",
          results: {
            valid: [],
            errors: [],
            warnings: [],
          },
          summary: {
            totalRows: 0,
            validRows: 0,
            errorRows: 0,
            warningRows: 0,
            newParents: 0,
            existingParents: 0,
            totalStudents: 0,
          },
        },
        processing: {
          status: "idle", 
          progress: {
            current: 0,
            total: 0,
            percentage: 0,
            currentOperation: "",
          },
          stats: {
            familiesCreated: 0,
            studentsEnrolled: 0,
            duration: 0,
          },
        },
        error: null,
      };

    default:
      return state;
  }
};
